import { render, staticRenderFns } from "./HandbooksMain.vue?vue&type=template&id=f489f7a8&scoped=true&"
import script from "./HandbooksMain.vue?vue&type=script&lang=js&"
export * from "./HandbooksMain.vue?vue&type=script&lang=js&"
import style0 from "./HandbooksMain.vue?vue&type=style&index=0&id=f489f7a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f489f7a8",
  null
  
)

export default component.exports